import { render } from "./energymonitor.vue?vue&type=template&id=22afdb46"
import script from "./energymonitor.vue?vue&type=script&lang=js"
export * from "./energymonitor.vue?vue&type=script&lang=js"

import "./energymonitor.vue?vue&type=style&index=0&id=22afdb46&lang=less"
script.render = render

export default script